/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Contactus1Inputs */

const he_common_contactus1 = /** @type {(inputs: Common_Contactus1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צור קשר`)
};

const en_common_contactus1 = /** @type {(inputs: Common_Contactus1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Us`)
};

/**
* | output |
* | --- |
* | "Contact Us" |
*
* @param {Common_Contactus1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const common_contactus1 = /** @type {((inputs?: Common_Contactus1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Contactus1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_contactus1(inputs)
	return en_common_contactus1(inputs)
});
export { common_contactus1 as "common_contactUs" }